export default {"src":"/_next/static/media/logo.ac8bf50b.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};